export enum CartEventsEnum {
  RemoveCartEntry = 'RemoveCartEntry',
  UpdateCartEntryQty = 'UpdateCartEntryQty',
  AddToCart = 'AddToCart',
  ClearCartEntries = 'ClearCartEntries',
  MergeCartSuccess = 'MergeCartSuccess',
  GetCartOnIndexPage = 'GetCartOnIndexPage',
  OpenPromotionDrawer = 'OpenPromotionDrawer',
  RedirectToSubCart = 'RedirectToSubCart',
  UpdateMiniCartIcon = 'UpdateMiniCartIcon',
  GetCartList = 'GetCartList',
  GetWishlist = 'GetWishlist',
  ShowLoader = 'ShowLoader',
  HideLoader = 'HideLoader',
  IsGCOToggledStart = 'IsGCOToggledStart',
  IsGCOToggledEnd = 'IsGCOToggledEnd',
  EnableCheckout = 'EnableCheckout',
  DisableCheckout = 'DisableCheckout',
  ViewCart = 'ViewCart',
  AddToWishlist = 'AddToWishlist',
  RemoveWishlistEntry = 'RemoveWishlistEntry',
  ProceedToCheckout = 'ProceedToCheckout',
  RedeemFailed = 'RedeemFailed',
  RedeemSuccessful = 'RedeemSuccessful',
}
